import makeStyles from "@mui/styles/makeStyles";
import { FieldGroupProps } from "./FieldGroup.types";

export const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  items: (props: FieldGroupProps) => ({
    display: "flex",
    gap: props.gap,
  }),
  item: (props: FieldGroupProps) => {
    const style = {
      flex: "1",
      "&:not(:first-child) fieldset": {
        left: -1,
      },
      "&:first-child fieldset": {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
      },
      "&:last-child fieldset": {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
      },
      "& > div > div.Mui-disabled": {
        borderLeft: 0,
      },
      "&:first-child > div > .Mui-disabled": {
        borderLeft: 0,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
      },
      "&:last-child > div > .Mui-disabled": {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
      },
      "& > div > div > div.Mui-disabled": {
        borderLeft: 0,
      },
      "&:first-child > div > div > .Mui-disabled": {
        borderLeft: 0,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
      },
      "&:last-child > div > div > .Mui-disabled": {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
      },
    };
    return props.gap ? {} : style;
  },
  helperTextMargin: {
    marginBottom: 20,
  },
}));
